import { render, staticRenderFns } from "./ChooseRideComponent.vue?vue&type=template&id=49772f6d&scoped=true"
import script from "./ChooseRideComponent.vue?vue&type=script&lang=js"
export * from "./ChooseRideComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49772f6d",
  null
  
)

export default component.exports